import * as NFLIcons from '../teamIcons';

const teamIcons = {
    'Cardinals': NFLIcons.Cardinals,'Falcons': NFLIcons.Falcons,'Ravens': NFLIcons.Ravens,'Bills': NFLIcons.Bills,'Panthers':NFLIcons.Panthers,
    'Bears': NFLIcons.Bears,'Bengals': NFLIcons.Bengals,'Browns': NFLIcons.Browns,'Cowboys': NFLIcons.Cowboys,'Broncos': NFLIcons.Broncos,
    'Lions': NFLIcons.Lions,'Packers': NFLIcons.Packers,'Texans': NFLIcons.Texans,'Colts': NFLIcons.Colts,'Jaguars': NFLIcons.Jaguars,
    'Chiefs': NFLIcons.Chiefs,'Chargers': NFLIcons.Chargers,'Rams': NFLIcons.Rams,'Raiders': NFLIcons.Raiders,'Dolphins': NFLIcons.Dolphins,
    'Vikings': NFLIcons.Vikings,'Patriots': NFLIcons.Patriots,'Saints': NFLIcons.Saints,'Giants': NFLIcons.Giants,'Jets': NFLIcons.Jets,
    'Eagles': NFLIcons.Eagles,'Steelers': NFLIcons.Steelers,'Seahawks': NFLIcons.Seahawks,'Niners': NFLIcons.Niners,'Buccaneers': NFLIcons.Buccaneers,
    'Titans': NFLIcons.Titans,'Commanders': NFLIcons.Commanders
};

export default teamIcons;